import type { Router } from 'vue-router';

export function createPageGuard(router: Router) {
  router.afterEach((to) => {
    if (to?.meta?.title) document.title = `${to?.meta?.title ?? ''}`;
    // loadedPageMap.set(to.path, true);
  });
}
